<template>
  <div class="row">
    <div class="col-12 mb-3">
      <v-simple-input
        input-id="professional-card-number"
        label="Numéro de la carte professionnelle"
        :value="cardNumber"
        placeholder="XXXXX XXXXX XXXXX XXXXX"
        :validation-class="touchedFields.professionalCardNumber ? `is-${isCardNumberValid ? 'valid' : 'invalid'}` : ''"
        :error-message="touchedFields.professionalCardNumber && !isCardNumberValid ? 'Le numéro de la carte professionnelle doit contenir 20 caractères maximum' : ''"
        @input="$emit('update:card-number', $event)"
        @blur="$emit('touch', 'professionalCardNumber')"
      />
    </div>
    <div class="col-12 col-md-6 mb-3">
      <v-simple-input
        input-id="delivery-city"
        label="Délivrée par la CCI de"
        :value="deliveryCity"
        placeholder="Ex: Paris"
        :validation-class="touchedFields.deliveryCity ? `is-${isCityValid ? 'valid' : 'invalid'}` : ''"
        :error-message="touchedFields.deliveryCity && !isCityValid ? 'La CCI de délivrance est requise' : ''"
        @input="$emit('update:delivery-city', $event)"
        @blur="$emit('touch', 'deliveryCity')"
      />
    </div>
    <div class="col-12 col-md-6 mb-3">
      <v-simple-input

        input-id="delivery-date"
        label="Date de délivrance"
        type="date"
        :value="deliveryDate"
        :validation-class="touchedFields.deliveryDate ? `is-${isDateValid ? 'valid' : 'invalid'}` : ''"
        :error-message="touchedFields.deliveryDate && !isDateValid ? 'La date saisie n\'est pas valide' : ''"
        @input="$emit('update:delivery-date', $event)"
        @blur="$emit('touch', 'deliveryDate')"
      />
    </div>
  </div>
</template>

<script>
import SimpleInput from '@/components/common/input/SimpleInput.vue';

export default {
  name: 'CardInfoSection',
  components: {
    'v-simple-input': SimpleInput,
  },
  props: {
    cardNumber: { type: String, required: true },
    deliveryCity: { type: String, required: true },
    deliveryDate: { type: String, required: true },
    touchedFields: { type: Object, required: true },
  },
  emits: ['update:card-number', 'update:delivery-city', 'update:delivery-date', 'touch'],
  computed: {
    isCardNumberValid() {
      return this.cardNumber.length > 0 && /^.{1,20}$/.test(this.cardNumber.replace(/\s/g, ''));
    },
    isCityValid() {
      return this.deliveryCity.trim().length > 0;
    },
    isDateValid() {
      if (!this.deliveryDate) return false;
      const selectedDate = new Date(this.deliveryDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return selectedDate >= new Date('1900-01-01') && selectedDate <= today;
    },
  },
};
</script>
